import React from 'react';
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { getUserRole } from "../utils/index";
import apiUrl from "../apiUrlConstant";
import axios from "axios";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactS3Uploader from "react-s3-uploader";
import { fileUploadPath, getUserStorageType } from "../utils/index";

const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class AttachmentAdd extends React.Component {

    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
        });

        this.state = {
            users: [],
            role: getUserRole(),
            initialValues: {
                title: '',
                file: ''
            },
            storageType: getUserStorageType() !== '' ? getUserStorageType() : 's3',
            attachfileName: '',
            attachfileTitle: ''
        };

        this.handleAttachmentSubmit = this.handleAttachmentSubmit.bind(this);
        this.generateRandomFilename = this.generateRandomFilename.bind(this);
        this.onUploadStart = this.onUploadStart.bind(this);
        this.onUploadFinish = this.onUploadFinish.bind(this);
        this.onUploadError = this.onUploadError.bind(this);
        this.onSignedUrl = this.onSignedUrl.bind(this);
        this.uploadLocalFile = this.uploadLocalFile.bind(this);
    }

    handleAttachmentSubmit(values, { setSubmitting }) {
        setSubmitting(true);
        this.setState({
            attachfileTitle: values.title,
        }, () => {
            if(this.state.storageType === 's3'){
                this.uploader.uploadFile();
            }else{
                this.onUploadFinish({});
            }
            
        });
    }

    generateRandomFilename(filename) {
        const ext = filename.split('.').pop();
        const randomString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        return `${randomString}.${ext}`;
    }

    onUploadStart(file, next) {
        const allowedExtensions = ["pdf", "png", "jpeg", "jpg", "gif", "xls", "xlsx"];
        let extension = file.name.split('.').pop().toLowerCase();

        if (!allowedExtensions.includes(extension)) {
            this.setState({ fileError: "Invalid file type! Allowed: PDF,GIF, PNG, JPEG, XLS, XLSX" });

            if (this.formikProps) {
                this.formikProps.setSubmitting(false);
            }

            return; // Stop upload
        } else {
            this.setState({ fileError: "" }); // Clear error if valid
        }

        let filename = this.generateRandomFilename(file.name);
        this.setState({ attachfileName: filename }, () => {
            next(file);
        });
    }

    onUploadFinish({ signedUrl, file }) {

        var attachmentData = {
            title: this.state.attachfileTitle,
            url: this.state.storageType=='s3'?fileUploadPath() + 'lead/' + this.props.leadId + '/' + this.state.attachfileName:this.state.attachfileName,
            lead_id: this.props.leadId,
            storage_type: this.state.storageType
        };

        axios.post(`${apiUrl.apiUrl.url}/leads/add-attachment`, attachmentData, { headers })
            .then(response => {
                if (response.data.status === 'success') {
                    this.props.closeModal();
                } else {
                    console.error('Error:', response.data);
                }
            })
            .catch(error => {
                console.error('Upload error:', error);
            });
    }

    onUploadError(error) {
        console.error('Upload error:', error);
    }

    onSignedUrl(signingUrl) {
        //console.log('Signing URL:', signingUrl);
    }

    uploadLocalFile = (e) => {
        e.preventDefault();
      
        const formData = new FormData();
        formData.append(
          'imageFile', e.target.files[0]
        );

        // Allowed file extensions
        const allowedExtensions = ["pdf", "png", "jpeg", "jpg", "gif", "xls", "xlsx"];
        let extension = e.target.files[0].name.split('.').pop().toLowerCase();

        // Check if the extension is valid
        if (!allowedExtensions.includes(extension)) {
            this.setState({ fileError: "Invalid file type! Allowed: PDF,GIF, PNG, JPEG, XLS, XLSX" });
            e.target.value = ""; // Reset file input

            if (this.formikProps) {
                this.formikProps.setSubmitting(false);
            }

            return;
        } else {
            this.setState({ fileError: "" }); // Clear error if valid
        }

        //console.log(e.target.files[0]);

        let filename = this.generateRandomFilename(e.target.files[0].name);
    
        formData.append(
          'file_name', 'lead_'+this.props.leadId+'_'+filename
        );

        this.setState({ attachfileName: 'lead_'+this.props.leadId+'_'+filename });
      
        try {
          axios({
            method: "post",
            url: `${apiUrl.apiUrl.url}/upload-document/save`,
            data: formData, 
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (response) {
            
          }).catch(function (error) {
            console.error('Error uploading file:', error);
          });
    
        } catch (error) {
          console.error('Error uploading file:', error);
        }
    }

    render() {
        return (
            <div>
                <Formik
                    enableReinitialize={true}
                    initialValues={this.state.initialValues}
                    onSubmit={(values, actions) => {

                        this.formikProps = actions;

                        if (!this.validator.allValid()) {
                            this.validator.getErrorMessages();
                            this.validator.showMessages();
                            return false;
                        }
                        this.handleAttachmentSubmit(values, actions);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <div className="unitFormContainerNew">
                            <Form autoComplete="off"
                             onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission on Enter key press
                                        }
                                    }} onSubmit={handleSubmit}>
                                <div className="newGridSectionParent">
                                    <div className="newGridSectionForFormMain newGridSectionForFormMainOneFr">
                                        <div className="newGridSectionInner">
                                            <label>Title <span className="astrik">*</span></label>
                                            <div className="position-relative">
                                                <Field type="text" name="title" onChange={handleChange} />
                                                {this.validator.message("Title", values.title, "required", { className: "text-danger" })}
                                            </div>
                                        </div>
                                        <div className="newGridSectionInner">
                                            <label>Upload File <span className="astrik">*</span></label>
                                            <div className="position-relative">
                                                {this.state.storageType=='s3'?
                                                <>
                                                <ReactS3Uploader
                                                    signingUrl={`/site/get-s3signed-url`}
                                                    signingUrlMethod="GET"
                                                    accept=".pdf, .png, .gif, .jpeg, .jpg, .xls, .xlsx"
                                                    s3path={`${fileUploadPath()}lead/${this.props.leadId}/`}
                                                    preprocess={this.onUploadStart}
                                                    onSignedUrl={this.onSignedUrl}
                                                    onProgress={this.onUploadProgress}
                                                    onError={this.onUploadError}
                                                    onFinish={this.onUploadFinish}
                                                    signingUrlWithCredentials={false}
                                                    uploadRequestHeaders={{}}
                                                    contentDisposition="attachment"
                                                    scrubFilename={() => this.state.attachfileName}
                                                    server={`${apiUrl.apiUrl.url}`}
                                                    inputRef={(cmp) => (this.uploadInput = cmp)}
                                                    autoUpload={false}
                                                    ref={(uploader) => {
                                                        this.uploader = uploader;
                                                    }}
                                                />
                                                

                                                </>
                                                :
                                                <input type="file" 
                                                accept=".pdf, .png, .gif, .jpeg, .jpg, .xls, .xlsx"
                                                onChange={(e) => {
                                                    this.uploadLocalFile(e);
                                                }} /> 
                                                }

                                                {this.state.fileError && (
                                                    <p className="text-danger mt-1">{this.state.fileError}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                        <button type="button" className='cancel_button' onClick={this.props.closeModal}>
                                            Cancel
                                        </button>
                                        <button type="submit" className='add_button' disabled={isSubmitting}>
                                            {isSubmitting && <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />} Submit
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    )}
                </Formik>
            </div>
        );
    }
};

export default AttachmentAdd;
